import React from 'react';
import { Mail, Phone, MapPin, CheckCircle2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Wholesale() {
  return (
    <div className="min-h-screen bg-white pb-32">
      {/* Header */}
      <div className="bg-spice-surface border-b border-spice-border py-12 sm:py-20 text-center relative overflow-hidden px-4">
        <h1 className="text-3xl md:text-5xl font-serif font-bold mb-4 text-spice-dark">Wholesale & Bulk Orders</h1>
        <p className="text-base md:text-lg text-spice-muted max-w-2xl mx-auto">
          Partner with Ajjas Masala for premium quality spices at direct manufacturer prices.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16">
          
          {/* Info Side */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="h-[1px] w-8 bg-spice-red"></span>
              <span className="text-spice-red font-bold text-xs uppercase tracking-[0.2em]">Our Promise</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-spice-dark mb-8">Why Partner With Us?</h2>
            <div className="space-y-8">
              {[
                { title: 'Direct Manufacturer Pricing', desc: 'No middlemen. Get the best rates directly from our manufacturing unit.' },
                { title: 'Consistent Quality', desc: 'Standardized ASTA colors and pungency levels batch after batch.' },
                { title: 'Custom Grinding & Blending', desc: 'We can match your exact specifications for mesh size, color, and heat.' },
                { title: 'Private Labeling / White Label', desc: 'Launch your own brand with our premium spices packaged in your custom pouches.' }
              ].map((item, idx) => (
                <div key={idx} className="flex">
                  <div className="w-6 h-6 rounded-full bg-spice-red text-white flex items-center justify-center flex-shrink-0 mr-4 font-bold text-xs">✓</div>
                  <div>
                    <h3 className="font-bold text-lg text-spice-dark uppercase tracking-wide text-sm">{item.title}</h3>
                    <p className="text-spice-muted mt-1 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-12 bg-spice-light p-8 border border-spice-border">
              <h3 className="font-bold text-spice-dark uppercase tracking-widest text-sm mb-4">Minimum Order Quantity (MOQ)</h3>
              <ul className="space-y-3 text-spice-muted text-sm leading-relaxed">
                <li className="flex gap-2"><span className="text-spice-red">■</span> Bulk Sacks (25kg/50kg): Minimum 100 kg per item</li>
                <li className="flex gap-2"><span className="text-spice-red">■</span> Retail Packs (100g-1kg): Minimum 500 pouches</li>
                <li className="flex gap-2"><span className="text-spice-red">■</span> Private Label: Minimum 1000 pouches</li>
              </ul>
            </div>
          </div>

          {/* Form Side */}
          <div className="bg-white p-8 border border-spice-border">
            <h2 className="text-xl sm:text-2xl font-serif font-bold text-spice-dark mb-6 sm:mb-8">Request Wholesale Pricing</h2>
            <form className="space-y-6" onSubmit={(e) => {
                e.preventDefault();
                toast.success('Thank you for your enquiry. Our B2B team will contact you shortly.');
              }}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Contact Name</label>
                  <input required type="text" className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans" />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Company Name</label>
                  <input required type="text" className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans" />
                </div>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Email Address</label>
                  <input required type="email" className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans" />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Phone Number</label>
                  <input required type="tel" className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans" />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Business Type</label>
                <select className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans appearance-none">
                  <option>Distributor / Wholesaler</option>
                  <option>Restaurant / Hotel (HoReCa)</option>
                  <option>Retail Supermarket</option>
                  <option>Food Manufacturer</option>
                  <option>Other</option>
                </select>
              </div>

              <div>
                <label className="block text-xs font-bold uppercase tracking-widest text-spice-muted mb-2">Requirements</label>
                <textarea required rows={4} className="w-full px-4 py-3 border border-spice-border rounded-none focus:ring-0 focus:border-spice-red outline-none bg-spice-light font-sans" placeholder="e.g. Need 500kg of Salem Turmeric..."></textarea>
              </div>

              <button type="submit" className="w-full bg-spice-dark hover:bg-spice-red text-white py-4 px-6 rounded-none font-bold uppercase tracking-widest text-sm transition-colors text-center mt-4">
                Submit Enquiry
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
